import React from 'react';

const SvgWrapper = (props) => {
  return (
    <img src={props.src} alt={props.alt} style={props.style} className={props.className} />
  );
}

export default SvgWrapper;